import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { INDRAApiService } from "@ibe.services/api.indra.service";
import { INDRAParallelService } from '@ibe.services/parallel.indra.service';
import { finalize } from 'rxjs/operators';
import { URL_ROOT, 
		URL_CREATE_UPDATE_NEW_CONTACT,
		MOCK_URL_CREATE_NEW_PNR_CONTACT,
		MOCK_STATUS } from "@ibe.config";

@Injectable({
	providedIn: 'root'
})

export class INDRAContactsService {
	constructor(
		private http: HttpClient,
		private api: INDRAApiService,
		private parallelService: INDRAParallelService
	) { }

	public INDRA_EditContacts(pnr: string, contact: any) {
		const URL_PNR_CONTACT_EDIT = `${URL_ROOT}booking/pnr/${pnr}/contacts/update`;
		return this.api.INDRA_put<any>(URL_PNR_CONTACT_EDIT, contact);
	}
	
	public INDRA_CreateContacts(contact: any) {
		if (MOCK_STATUS.NEW_PNR_CONTACT) {
			return this.api.INDRA_get<any>(MOCK_URL_CREATE_NEW_PNR_CONTACT);
		} else {
			return this.api.INDRA_put<any>(URL_CREATE_UPDATE_NEW_CONTACT, contact).pipe(
				finalize(() => {
					this.parallelService.INDRA_setTriggerCreateContact(false);
					this.parallelService.INDRA_setIsContactCreated(true);
				})
			);
		}
	}
}
